
function createBrandGroupMap(brandGroups) {
    const map = new Map();
    for (const [group, brands] of Object.entries(brandGroups)) {
        for (const brand of brands) {
            map.set(brand, group);
        }
    }
    return map;
}

const brandGroups = {
    "Emami": [
        "Fair and Handsome - National", "Fair and Handsome - Grocery", "Fair and Handsome",
        "BoroPlus", "Boroplus - National", "Boroplus - Grocery",
        "Navratna", "Navratna - National", "Navratna - Grocery", "Navratna Gold - National",
        "Zandu Chyawanprash", "Zandu Display", "Zandu Pancharishta",
        "Kesh King - Grocery", "Kesh King",
        "Emami Grooming - National", "Emami Minutes", "Emami Foods", "Emami Grocery New",
        "Emami Health", "Emami All Accounts", "Emami - Grocery", "Emami Ltd",
        "Dermicool - National", "Dermicool - Grocery", "Dermicool",
        "7 Oils in One - National", "7 oils in one",
        "The Man Company - Premium Grooming Brand", "Brillare Ad Account"
    ],
    "Bajaj Consumer Care Limited": [
        "BAJAJ CONSUMER CARE LIMITED (Grocery)", "BAJAJ CONSUMER CARE LIMITED (National)",
        "Bajaj Seasonal PO", "Bajaj Core PO", "Bajaj MW PO", "Bajaj NPG PO",
        "Bajaj Almond Drops", "Bajaj Light Hair Oil", "Nomarks"
    ],
    "FIXMYCURLS INDIA PRIVATE LIMITED": [
        "FIXMYCURLS INDIA PRIVATE LIMITED_self-serve", "FIXMYCURLS", "Fix My Curls"
    ],
    "Open Secret": [
        "Open Secret", "Open Secret Ads", "Open Secret_PO"
    ],
    "Me n Moms": [
        "Me n Moms"
    ],
    "Holistique Beauty Products Private Limited": [
        "Holistique Beauty Products Private Limited_self-serve"
    ],
    "Wellversed": [
        "Wellversed - seller"
    ],
    "Sirona Hygiene Private Limited": [
        "Sirona Hygiene Private Limited_self-serve_Brand", "Sirona", "Sirona_RO"
    ],
    "Nua": [
        "NuaWoman", "Nua (Prepaid) - Grocery", "Nua - seller", "Nua Postpaid - Grocery", "Nua"
    ],
    "Reequil India Private Limited": [
        "Reequil India Private Limited_self-serve", "Reequil India Pvt. Ltd. - SJIT_self-serve",
        "ReequilIndia - seller", "Re'equil", "Re'equil SA"
    ],
    "Dot & Key": [
        "Dot and Key", "DOT & KEY WELLNESS PRIVATE LIMITED_self-serve_Brand", "Dot & Key PO"
    ],
    "Minimalist": [
        "Minimalist-KSA", "Minimalist US", "Minimalist Postpaid", "Minimalist",
        "MINIMALIST SCIENCE TRADING L.L.C_SA", "MINIMALIST SCIENCE TRADING L.L.C",
        "Minimalist Skincare", "Minimalist Science Ltd"
    ],
    "Relaxo Footwears Limited": [
        "RELAXO FOOTWEARS LIMITED_self-serve", "RELAXO FOOTWEARS LIMITED", "Relaxo"
    ],
    "Arvind Lifestyle Brands Limited": [
        "ARVIND LIFESTYLE BRANDS LIMITED_self-serve_6262", "ARVIND LIFESTYLE BRANDS LIMITED_self-serve_28653",
        "Arvind"
    ],
    "Campus Activewear Limited": [
        "CAMPUS ACTIVEWEAR LIMITED_self-serve_brand", "CAMPUS ACTIVEWEAR LIMITED - PO", "Campus"
    ],
    "Allen Solly": [
        "Allen Solly Wearables_PO", "Allen Solly Kid", "Allen Solly Men's", "Allen Solly Women", "Allen Solly"
    ],
    "Polycab": [
        "Polycab PO Alpha", "Geyser Polycab MP", "Fan Polycab PO MP", "Polycab Wires",
        "Polycab Geysers", "Polycab Branding Campaigns- All Products"
    ],
    "Orient Electric": [
        "Orient Room Heater POLimit", "Orient AirCoolers POLimit", "Orient KA POLimit",
        "Orient WH POLimit", "Orient Fans POLimit", "Orient Electric Lighting"
    ],
    "The Moms Co": [
        "The Moms Co_LOC_1", "The Moms Co._LOC", "The Moms Co - Baby Category"
    ],
    "ADITI TOYS PRIVATE LIMITED": [
        "ADITI TOYS PRIVATE LIMITED_self-serve", "ADITITOYSPRIVATELIMITED"
    ],
    "Baby & Mom Retail Private Limited": [
        "BABY & MOM RETAIL PRIVATE LIMITED_self-serve", "Baby & Mom Retail Pvt. Ltd.", "BABYMOMRETAILPVTLTD"
    ],
    "Nasher Miles": [
        "Nasher Miles Private Limited_self-serve_brand", "Nasher Miles"
    ],
    "Kapiva": [
        "Kapiva_HC", "Kapiva", "Kapivamen", "KAPIVA AYURVEDA"
    ],
    "Zydus": [
        "Zydus_Cuticolor", "ZYDUS_GRD", "GRD_Zydus_PO"
    ],
    "BeatXP": [
        "BeatXP HCA", "Beat XP", "BeatXP TWS", "beatXP"
    ],
    "Foxtale": [
        "Foxtale", "Foxtale - Ads", "Foxtale - Seller"
    ],
    "Neeman's Private Limited": [
        "NEEMAN'S PRIVATE LIMITED_self-serve", "Neemans Private Limited", "Neeman's Shoes // India’s Most Comfortable Shoes"
    ],
    "XYXX": [
        "XYXX Flipkart Ads", "XYXX"
    ],
    "Arcatron": [
        "Arcatron", "Arcatron - seller"
    ],
    "InLabs Lifesciences": [
        "Inlabs Lifesciences Private Limited", "InLabsLifesciences"
    ],
    "Skillmatics": [
        "Skillmatics", "Skillmatics UK"
    ],
    "The Indus Valley": [
        "The Indus Valley"
    ],
    "Saffola": [
        "Saffola Oats", "Saffola"
    ],
    "Wonder Care": [
        "WonderCare AE", "Wondercare-AU", "Wonder Care Europe", "Wonder Care India", "Wonder Care"
    ],
    "Pilgrim": [
        "Pilgrim", "Pilgrim India"
    ],
    "Ugaoo": [
        "UGAOO - seller", "Ugaoo"
    ],
    "Lifelong": [
        "Lifelong Home", "Lifelong PCA", "Lifelong Thrasio", "Lifelong"
    ],
    "Duroflex": [
        "Duroflex PO", "Duroflex"
    ],
    "Noise": [
        "Noise Wearables", "Noise Audio", "Noise"
    ],
    "Bumtum": [
        "Bumtum", "Bumtum - Grocery", "Bumtum_PO"
    ],
    "livon": [
        "livon - Grocery", "livon", "livon Serum"
    ],
    "Boult": [
        "Boult Audio Ro", "Boult"
    ],
    "Kaya": [
        "KAYA", "KAYA - Grocery", "KAYA SKIN CLINIC"
    ],
    "Organic India": [
        "ORGANIC INDIA", "Organic India"
    ],
    "Sleepyhead": [
        "Sleepyhead", "MySleepyhead"
    ],
    "Fast&Up": [
        "FastandUp - seller", "Fast&Up"
    ],
    "Urban Space": [
        "Urban Space - seller", "Urban Space"
    ],
    "Casotec": [
        "Casotec1 - seller", "Casotec1", "Casotec"
    ],
    "HexClad": [
        "HexClad CA", "HexClad USA", "HexClad MX"
    ],
    "Squatty Potty": [
        "Squatty Potty", "Squatty Potty LLC -( dummy - nis- home improvement)", "Squatty Potty LLC - Sampling", "Squatty Potty LLC"
    ],
    "Zouk": [
        "ZOUK", "Zouk"
    ],
    "R for Rabbit": [
        "RforRabbit", "R for Rabbit"
    ],
    "OZiva": [
        "OZiva_PO", "OZiva Store"
    ]
};


const brandGroupMap = createBrandGroupMap(brandGroups);

export const getGroup = (brandName) => {
    return brandGroupMap.get(brandName) || brandName;
}